import { Injectable } from "@angular/core";
import { AbstractService } from "../common/abstract-service";
import { Search } from "../common/search";
import { Allegato } from "../model/allegato";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import {
  ALLEGATI_API_PATH,
  DOCUMENTS_MIMETYPE_API_PATH,
  TABLE_KEY,
  TABLE_NAME,
  TOKEN_KEY,
} from "../constants/constants";
@Injectable({
  providedIn: "root",
})
export class AllegatoService extends AbstractService<Allegato> {
  constructor(protected http: HttpClient) {
    super(ALLEGATI_API_PATH, http);
  }

  public getId(element: Allegato) {
    return element.uuid;
  }

  public buildSearch() {
    this.search = new Search<Allegato>(Allegato);
  }

  public download(uuid: string) {
    return this.http
      .get(this.url + "/" + uuid + "/download", { responseType: "blob" })
      .pipe(catchError(this.handleError));
  }

  public single(id: string): Observable<Allegato> {
    return this.http.get<Allegato>(this.url + "/" + id);
  }

  public persistAllegato(allegato: Allegato, blob: any): Promise<Allegato> {
    return new Promise((resolve, reject) => {
      if (allegato) {
        const formData: FormData = new FormData(),
          xhr: XMLHttpRequest = new XMLHttpRequest();
        formData.append("file", blob);
        formData.append(TABLE_NAME, allegato.table_name);
        formData.append(TABLE_KEY, allegato.table_key);
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(JSON.parse(xhr.response));
            } else {
              reject(xhr.response);
            }
          }
        };
        xhr.open("POST", this.url, true);
        const token = localStorage.getItem(TOKEN_KEY);
        xhr.setRequestHeader("Authorization", "Bearer " + token);
        xhr.send(formData);
      }
    });
  }
}
